export function checkPriceEditable(article_code) {
    return article_code === 8090 || article_code === 8095;
}